var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top-main"}},[_c('div',{staticClass:"inner-main",attrs:{"dir":_vm.uiDirection}},[_c('div',{staticClass:"container-header",attrs:{"id":"container-header"}},[_c('header-main'),_vm._v(" "),_c('nav-category',{attrs:{"mode":"main"}})],1),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('cart')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6a5372","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
// module id = rXeK
// module chunks = 4